const Send2 = ({ height = "32" }) => (
  <svg
    height={height}
    viewBox="0 0 30 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_2390_19287)">
      <path
        d="M9.96156 6.72047L18.9484 3.72487C22.9813 2.38056 25.1724 4.58227 23.8387 8.61521L20.8431 17.602C18.8319 23.6461 15.5293 23.6461 13.5182 17.602L12.629 14.9345L9.96156 14.0454C3.91744 12.0342 3.91744 8.74223 9.96156 6.72047Z"
        stroke="#EFF1F5"
        strokeWidth="1.97589"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8303 14.479L16.6198 10.679"
        stroke="#EFF1F5"
        strokeWidth="1.97589"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_2390_19287"
        x="0.44043"
        y="2.34326"
        width="28.7759"
        height="28.7798"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2390_19287"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2390_19287"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default Send2;
